<template>

    <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="isNew" style="margin-top: 30px;" color="green" dark v-bind="attrs" v-on="on"
                @click="clearData">
                <v-icon size="20">mdi-plus</v-icon>
                {{ $t('Add Product') }}
            </v-btn>
            <v-btn v-if="!isNew" @click="fetchData" v-on="on" v-bind="attrs" icon> <v-icon color="blue">mdi-pen</v-icon>
            </v-btn>
        </template>
        <v-card style="transform: none !important;">
            <v-card-title class="justify-center">
                <span class="text-h3">{{ isNew ? $t('Add Product') : $t('edit') }}</span>
            </v-card-title>
            <v-card-text>
                <v-container v-if="isNew">
                    <v-row >
                        <v-col class="d-flex justify-center" cols="12" sm="6" md="6">
                            <app-image-input-file :srcImage="data.image ? getImgUrl(data.image) : ''" ref="childImage"
                                :resetImage="resetImageInput" :createFeature="true" :imgHeight="140" :imgWidth="125"
                                :placeHolder="$t('image')" @fileValue="setMealPhoto($event)"
                                :dark="$store.state.isDarkMode" @fileRemoved="deleteMealPhoto"></app-image-input-file>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field :dark="$store.state.isDarkMode" v-model="data.name" dense :label="$t('name')"
                                :hint="$t('requird')" required outlined></v-text-field>
                            <v-text-field class="py-5" :dark="$store.state.isDarkMode" dense v-model="data.barcode"
                                :label="$t('Barcode')" outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" class="py-0">
                            <v-autocomplete :dark="$store.state.isDarkMode" v-model="data.status" :items="myitems"
                                item-text="name" :hint="$t('requird')" item-value="value" outlined dense
                                :label="$t('status')"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" class="py-0">
                            <v-text-field :dark="$store.state.isDarkMode" v-model="data.price" outlined dense :label="$t('price')"
                                type="number" :hint="$t('requird')" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" class="py-0">
                            <v-autocomplete :dark="$store.state.isDarkMode" v-model="data.brand_id" :items="brands"
                                item-text="name" :hint="$t('requird')" item-value="id" outlined dense
                                :label="$t('Company Name')"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" class="py-0">
                            <v-autocomplete :dark="$store.state.isDarkMode" v-model="data.category_id"
                                :items="categories" item-text="name" :hint="$t('requird')" item-value="id" outlined dense
                                :label="$t('Category Name')"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" class="py-0">

                            <v-textarea :dark="$store.state.isDarkMode" v-model="data.description" full-width dense outlined 
                                :label="$t('description')" :hint="$t('requird')" required></v-textarea>
                        </v-col>
                        <div class="d-flex justify-space-between align-center mb-5">
                            <h4 style="color: var(--bg-color--font)">{{ $t('material specifications') }}</h4>
                            <v-icon class="account-specifications__add-icon"
                                @click="data.attributes.push({ key: null, value: null });">mdi-plus-thick</v-icon>
                        </div>
                        <v-fade-transition group mode="out-in">
                            <v-row v-for="(specification, index) in data.attributes" :key="index">
                                <v-col md="3" class="py-0">
                                    <v-text-field outlined dense v-model="specification.key"></v-text-field>
                                </v-col>
                                <v-col md="7" class="py-0">
                                    <v-text-field outlined dense v-model="specification.value"></v-text-field>
                                </v-col>
                                <v-col md="2">
                                    <v-icon color="red" @click="data.attributes.splice(index, 1)">mdi-delete</v-icon>
                                </v-col>
                            </v-row>
                        </v-fade-transition>
                    </v-row>
                </v-container>
                <v-container v-else>
                    <v-tabs background-color="transparent" v-model="tab" class="mb-3">
                        <v-tab>{{ $t('Material') }}</v-tab>
                        <v-tab>{{ $t('material specifications') }}</v-tab>
                        <v-tab>{{ $t('Images') }}</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab" class="pt-3">
                        <v-tab-item>
                            <v-row>
                                <v-col cols="12" sm="6" md="6" class="d-flex justify-center">
                                    <app-image-input-file :srcImage="data.image ? getImgUrl(data.image) : ''"
                                        ref="childImage" :resetImage="resetImageInput" :createFeature="true"
                                        :imgHeight="140" :imgWidth="125" :placeHolder="$t('image')"
                                        @fileValue="setMealPhoto($event)" :dark="$store.state.isDarkMode"
                                        @fileRemoved="deleteMealPhoto"></app-image-input-file>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field :dark="$store.state.isDarkMode" v-model="data.name"
                                        :label="$t('name')" :hint="$t('requird')" required></v-text-field>
                                    <v-text-field class="py-5" :dark="$store.state.isDarkMode" dense
                                        v-model="data.barcode" :label="$t('Barcode')"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-autocomplete :dark="$store.state.isDarkMode" v-model="data.status"
                                        :items="myitems" item-text="name" :hint="$t('requird')" item-value="value"
                                        :label="$t('status')"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field :dark="$store.state.isDarkMode" v-model="data.price"
                                        :label="$t('price')" type="number" :hint="$t('requird')"
                                        required></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-autocomplete :dark="$store.state.isDarkMode" v-model="data.brand_id"
                                        :items="brands" item-text="name" :hint="$t('requird')" item-value="id"
                                        :label="$t('Company Name')"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-autocomplete :dark="$store.state.isDarkMode" v-model="data.category_id"
                                        :items="categories" item-text="name" :hint="$t('requird')" item-value="id"
                                        :label="$t('Category Name')"></v-autocomplete>
                                </v-col>
                                <v-col cols="12">

                                    <v-text-field :dark="$store.state.isDarkMode" v-model="data.description"
                                        :label="$t('description')" :hint="$t('requird')" required></v-text-field>
                                </v-col>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="dialog = false">
                                        {{ $t('cancel') }}
                                    </v-btn>
                                    <v-btn :color="btnColor" text @click="storeMeal">
                                        <span v-if="!meal.storeMealState.loading"> {{ $t('storage') }}</span>
                                        <v-progress-circular v-else :width="3" color="blue"
                                            indeterminate></v-progress-circular>
                                    </v-btn>
                                </v-card-actions>
                            </v-row>
                        </v-tab-item>
                        <v-tab-item>
                            <div class="d-flex justify-space-between align-center mb-5">
                                <v-icon class="account-specifications__add-icon"
                                    @click="data.attributes.push({ key: null, value: null });">mdi-plus-thick</v-icon>
                            </div>
                            <v-fade-transition group mode="out-in">
                                <v-row v-for="(specification, index) in data.attributes" :key="index">
                                    <v-col md="3" class="py-0">
                                        <v-text-field outlined dense v-model="specification.key"></v-text-field>
                                    </v-col>
                                    <v-col md="7" class="py-0">
                                        <v-text-field outlined dense v-model="specification.value"></v-text-field>
                                    </v-col>
                                    <v-col md="2">
                                        <v-icon color="red"
                                            @click="data.attributes.splice(index, 1)">mdi-delete</v-icon>
                                    </v-col>
                                </v-row>
                            </v-fade-transition>
                            <v-card-actions class="d-flex justify-end">
                                <v-btn :loading="submitSpLoading" depressed color="blue-grey" class="white--text"
                                    @click="addSp">{{ $t("storage") }}</v-btn>
                                <v-btn depressed color="primary" @click="dialog = false">{{
                                    $t("cancel")
                                }}</v-btn>
                            </v-card-actions>
                        </v-tab-item>
                        <v-tab-item>
                        <v-row >
                            <v-col class="d-flex justify-center" v-for="n in 4" cols="12" sm="6" md="6">
                                <app-image-input-file :srcImage="data.images && data.images[n - 1] ? getImgUrl(data.images[n - 1].image) : ''"
                                    ref="childImage" :resetImage="resetImageInput" :createFeature="true"
                                    :imgHeight="140" :imgWidth="125" :placeHolder="$t('image')"
                                    @fileValue="setMealPhotoImage($event)" :dark="$store.state.isDarkMode"
                                    @fileRemoved="deleteMealPhotoImage(n - 1)"></app-image-input-file>
                            </v-col>
                        </v-row>
                        <v-card-actions class="d-flex justify-center">
                            <v-btn :loading="submitImgLoading" depressed color="blue-grey" class="white--text"
                                @click="addImg">{{ $t("storage") }}</v-btn>
                            <v-btn depressed color="primary" @click="dialog = false">{{
                                $t("cancel")
                            }}</v-btn>
                        </v-card-actions>       
                    </v-tab-item>
                    </v-tabs-items>
                    
                </v-container>
            </v-card-text>
            <v-card-actions v-if="isNew">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">
                    {{ $t('cancel') }}
                </v-btn>
                <v-btn :color="btnColor" text @click="storeMeal">
                    <span v-if="!meal.storeMealState.loading"> {{ $t('storage') }}</span>
                    <v-progress-circular v-else :width="3" color="blue" indeterminate></v-progress-circular>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>
<script>
import imageInputFile from "../../../../../components/base/imageInputFile.vue";
import { meal } from '../../../../../store/auth';
import axios from "axios";
import AutoCompleteField from "../../../components/core/AutoCompleteField.vue";
import { mapGetters, mapActions } from "vuex";
const mealState = () => {
    return {
        name: null,
        description: '',
        image: null,
        status: '',
        price: null,
        barcode: null,
        category_id: null,
        brand_id: null,
        attributes: [],
        images: [],
    }
}
export default {
    components: {
        appImageInputFile: imageInputFile,
        AutoCompleteField,
    },
    data() {
        return {
            tab: 0,
            meal,
            submitSpLoading: false,
            submitImgLoading: false,
            data: mealState(),
            resetImageInput: false,
            imagePath: '',
            dialog: false,
            imagesPost: [],
            items: [
                {
                    name: 'available',
                    value: 'available'
                },
                {
                    name: 'unavailable',
                    value: 'unavailable'
                }
            ],
            items2: [
                {
                    name: 'متوفر',
                    value: 'available'
                },
                {
                    name: ' غير متوفر',
                    value: 'unavailable'
                }
            ],
        }
    },
    props: {
        isNew: {
            type: Boolean,
            default: true,
        },
        idItem: Number,
    },
    methods: {
        ...mapActions({
            fetchProduct: "products/fetchProduct",
        }),
        getImgUrl(item) {
            let domain = `${this.$store.state.serverDomain}/storage/`
            return domain + item
        },
        setMealPhotoImage(file) {
            this.imagesPost.push(file);
        },
        async addImg() {
            this.submitImgLoading = true;
            if(this.imagesPost.length > 0) {
                let form = new FormData();
                this.imagesPost.forEach((item, index) => {
                    form.append(`images[${index}]`, item)
                });
                try {
                    await axios.post(`/catalog/product/${this.idItem}/images`, form);
                    this.$Notifications(
                        this.$t('add success'),
                        { rtl: true, timeout: 1000 },
                        "success"
                    );
                    this.$emit("submitted");
                    this.clearData();    
                } catch (error) {
                    
                }
            }
            this.submitImgLoading = false;
        },
        async deleteMealPhotoImage(index) {
            if (!this.data.images || !this.data.images[index]) return;
            const id = this.data.images[index].id;
            this.submitImgLoading = true;
            try {
                await axios.delete(`/catalog/product/${this.idItem}/images/${id}`);
                this.data.images.splice(index, 1);
                this.$Notifications(
                this.$t('delete success'),
                { rtl: true, timeout: 1000 },
                "success"
                );
            } catch (error) {
                console.log(error);
            }
            this.submitImgLoading = false;
        },
        async fetchData() {
            await this.fetchProduct(this.idItem);
            this.data = {
                ...mealState(),   
                ...this.product,  
            };
            this.data.category_id = this.data.category?.id;
            this.data.brand_id = this.data.brand?.id;
            if (!Array.isArray(this.data.images)) {
                this.data.images = [];
            }
        },
        
        clearData() {
            this.data = mealState(); 
            if (this.$refs.childImage) {
                const refs = Array.isArray(this.$refs.childImage)
                ? this.$refs.childImage
                : [this.$refs.childImage];
                refs.forEach(r => r.removeImageFile && r.removeImageFile());
            }
            this.imagesPost = [];
            this.dialog = false;
        },
        setMealPhoto(file) {
            this.data.image = file;
        },
        lengthArr(arr) {
            if (Array.isArray(arr) && arr.length)
                return false;
            else
                return true;
        },
        deleteMealPhoto() {
            this.data.image = null;
        },
        async storeMeal() {
            if (this.btnColor == 'blue') {
                try {
                    this.data.attributes = this.data.attributes.filter(
                        item => item.key && item.value
                    )
                    let form = new FormData();
                    for (let key in this.data) {
                        if (this.data[key]) {
                            if (key == 'attributes') {
                                this.data.attributes.forEach((item, index) => {
                                    form.append(`attributes[${index}][key]`, item.key)
                                    form.append(`attributes[${index}][value]`, item.value)
                                })
                            } else {
                                form.append(`${key}`, this.data[key])
                            }
                        }
                    }
                    await axios.post(this.isNew ? '/catalog/product' : `/catalog/product/${this.idItem}`, form);
                    this.$Notifications(
                        this.isNew ? this.$t('add success') : this.$t('edit success'),
                        { rtl: true, timeout: 1000 },
                        "success"
                    );
                    this.$emit("submitted");
                    this.clearData();
                } catch { }
            } else {
                this.$Notifications(
                    this.$t('please complete all info'),
                    { timeout: 4000, rtl: true },
                    "error"
                );
            }
        },
        async addSp() {
            this.submitSpLoading = true;
            try {
                this.data.attributes = this.data.attributes.filter(
                    item => item.key && item.value
                )
                await axios.post(`/catalog/product/${this.idItem}/attributes`, { attributes: this.data.attributes });
                this.$Notifications(
                    this.$t('edit success'),
                    { rtl: true, timeout: 1000 },
                    "success"
                );
                this.$emit("submitted");
                this.clearData();
                
            } catch { }
            this.submitSpLoading = false;

        }
    },
    computed: {
        ...mapGetters({
            categories: 'categories/getCategories',
            brands: 'brands/getBrands',
            product: 'products/getProduct',
        }),
        btnColor() {
            if (!this.data.name || !this.data.price || !this.data.status || !this.data.brand_id || !this.data.category_id) {
                return 'gray'
            } else {
                return 'blue'
            }
        },
        myitems() {
            if (this.$i18n.locale == 'en') {
                return this.items
            } else {
                return this.items2
            }
        },
    },
}
</script>
